import { Component } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';

// Player Credit Report (2026-07-16) — traces every credit grant/collect so
// earlier records can always be checked. Backed by /admin/player-credit/report.
@Component({
    selector: 'app-player-credit-report',
    templateUrl: './player-credit-report.component.html',
    styleUrls: ['./player-credit-report.component.scss']
})
export class PlayerCreditReportComponent {

    public data: any = { type: '' };
    public load: any = false;
    public items: any = [];
    public summary: any = { total_count: 0, total_grant: 0, total_collect: 0 };
    private selected_company: any = null;

    constructor(private http: HttpService, private activatedRoute: ActivatedRoute, private router: Router) {
        this.selected_company = this.http.getStaticSelectedCompany();

        let queryParams = this.activatedRoute.snapshot.queryParams;
        let available = false;

        if (queryParams.start_date) {
            this.data.start_date = queryParams.start_date;
            available = true;
        }
        if (queryParams.end_date) {
            this.data.end_date = queryParams.end_date;
            available = true;
        }
        if (queryParams.player_search) {
            this.data.player_search = queryParams.player_search;
            available = true;
        }
        if (queryParams.type) {
            this.data.type = queryParams.type;
            available = true;
        }

        if (!available) {
            // default to the last 7 days — matches the weekly collection cycle
            const to = new Date();
            const from = new Date();
            from.setDate(from.getDate() - 6);
            this.data.start_date = this.fmt(from);
            this.data.end_date = this.fmt(to);
        }

        this.filter();
    }

    fmt(d: Date) {
        return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    }

    async filter() {
        this.load = true;

        const post: any = { ...this.data };
        if (!post.type) {
            delete post.type;
        }

        let y: any = await this.http.post("/admin/player-credit/report", post);

        this.items = Array.isArray(y) ? y : [];
        this.summary = {
            total_count: this.items.length,
            total_grant: this.items.filter((v: any) => v.type == 'grant').reduce((s: number, v: any) => s + parseFloat(v.amount || 0), 0),
            total_collect: this.items.filter((v: any) => v.type == 'collect').reduce((s: number, v: any) => s + parseFloat(v.amount || 0), 0),
        };

        const queryParams = { ...this.data };
        delete queryParams.user_uuid;
        delete queryParams.company_uuid;
        this.router.navigate(['/lo', this.selected_company, 'player-credit-report'], { queryParams: queryParams });

        this.load = false;
    }
}
